/** Helpers WebGL2 mínimos: compilar shader, linkar programa. */

export function createShader(
  gl: WebGL2RenderingContext, type: number, source: string,
): WebGLShader {
  const sh = gl.createShader(type);
  if (!sh) throw new Error("createShader devolvió null");
  gl.shaderSource(sh, source);
  gl.compileShader(sh);
  if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) {
    const err = gl.getShaderInfoLog(sh);
    gl.deleteShader(sh);
    throw new Error(`Shader compile error:\n${err}\n--- source ---\n${source}`);
  }
  return sh;
}

export function createProgram(
  gl: WebGL2RenderingContext, vsSource: string, fsSource: string,
): WebGLProgram {
  const program = gl.createProgram();
  if (!program) throw new Error("createProgram devolvió null");
  const vs = createShader(gl, gl.VERTEX_SHADER, vsSource);
  const fs = createShader(gl, gl.FRAGMENT_SHADER, fsSource);
  gl.attachShader(program, vs);
  gl.attachShader(program, fs);
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    const err = gl.getProgramInfoLog(program);
    gl.deleteProgram(program);
    throw new Error(`Program link error: ${err}`);
  }
  return program;
}
